import React, { useState } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  isPlatform,
  IonCard,
  IonCardContent,
  IonImg,
  IonLabel,
  IonIcon,
  IonSegment,
  IonSegmentButton
} from "@ionic/react";
import "./Documents.scss";
import i18n from "../../../../i18n";
import { FetchDocumentModel } from "../../../models/myLoad/fetchDocument.model";
import {
  getTmsDocumentRequest
} from "../../../actions/myload/action";
import { useDispatch } from "react-redux";
import { getFormatedDateTime, documentTabNamesByModule } from "./utils";
import { ICON_PATH, ESOURCE_TYPE_CHECK } from "../../../utils/constants";
import { Browser } from "@capacitor/browser";
import { UploadDocument } from "./UploadDocument";
import { SourceTMSValidation } from "../../../utils/common";
export default (props: any) => {
  const dispatch = useDispatch();
  const fetchDocumentHandler = (
    documentType: any,
    documentNumber: string | null
  ) => {
    const documentModel = new FetchDocumentModel();
    const shipmentId = getShipmentID(props);
    documentModel.shipmentId = shipmentId;
    documentModel.documentType = documentType;
    documentModel.sourceTms = getSourceTMS(props);
    if (documentNumber) documentModel.documentNumber = documentNumber;
    const callback = (data: any) => {
      getBase64PDF(data);
    };
    dispatch(
      getTmsDocumentRequest({ query: documentModel.getDocument(), callback })
    );
  };
  const [selectedTab,setSelectedTab] = useState<string>("documents")
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");
  const paddingClass = isMobile ? "mobile-padding" : "web-padding";
  return (
    <>
      <div className="documents-component">
        {SourceTMSValidation(
          (props?.sourceTMS) || "",
          (props?.division) || "",
          ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE
        ) && <UploadDocument {...props} />}
        {SourceTMSValidation(
          (props?.sourceTMS) || "",
          (props?.division) || "",
          ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE
        ) && (
          <div className="documents">
            <IonCard
              class={`documents details-documents-component ${isMobile ? "" : "webBorder"}`}
            >
              <IonRow className="view-document-title-container">
                <IonCol size="9">
                  <IonSegment
                    mode="ios"
                    onIonChange={(e?: any) => {
                      setSelectedTab(e.detail.value);
                    }}
                    class="document-segment"
                    data-test="document-segment"
                    value={selectedTab}
                  >
                    {documentTabNamesByModule.map((tab: any) => {
                      return (
                        (SourceTMSValidation((props?.sourceTMS) || "",(props?.division) || "", tab.visibilityControllKey) &&
                          !(tab.visibilityControllKey === ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE && !props.isDrayRoute) &&
                            !(tab.visibilityControllKey === ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE && props?.references["relatedDocuments"]?.length < 1)) ?
                          <IonSegmentButton mode="ios" key={tab.key} value={tab.key}>
                            <div className="segment-title" data-test={tab.key}>
                              {tab.name}
                            </div>
                          </IonSegmentButton> :
                          null
                      );
                    })}
                  </IonSegment>
                </IonCol>
                <IonCol
                  data-testid="ion-col-click"
                  size="2.2"
                  offset="0.8"
                  className="refresh-container"
                  onClick={() => props.handleDocumentFetch(true)}
                >
                  <IonIcon
                    src="assets/icon/refresh.svg"
                    className="refresh-documents-icon"
                    data-test="refresh-documents-icon"
                  />
                  <span>Refresh</span>
                </IonCol>
              </IonRow>
              {props.references && props.references[selectedTab] && props.references[selectedTab].length > 0 ?
                (<IonCardContent>
                  <div className="documents-item-container">
                    <IonGrid className="documents-component">
                      {props?.references[selectedTab]?.map((ref: any, index: number) => (
                          <IonRow key={`${ref.type}_${index}`}>
                            <IonCol
                              className={paddingClass}
                              onClick={() =>
                                fetchDocumentHandler(
                                  ref.documentType,
                                  ref.documentNumber
                                )
                              }
                            >
                              <IonRow>
                                <IonImg
                                  className="doc-icon"
                                  src={ICON_PATH.doc_icon}
                                />
                                <IonLabel className={"document-name"}>
                                  {ref.displayName}
                                </IonLabel>
                              </IonRow>
                            </IonCol>
                            <IonCol className={paddingClass}>
                              {getFormatedDateTime(ref.createdDateTime)}
                            </IonCol>
                          </IonRow>
                        ))}
                    </IonGrid>
                  </div>
                </IonCardContent>
                )
                : (
                  <IonCardContent className="no-documents-found">
                    <div>{i18n.t("No documents available")}</div>
                  </IonCardContent>
                )}
            </IonCard>
          </div>
        )}
      </div>
    </>
  );
};
export const getSourceTMS = (props: any) =>{
  return (props?.sourceTMS) || "";
}

const getShipmentID = (props: any) => {
  return (props?.shipmentId) || "";
}

export const getBase64PDF = (data: any) => {
  const base64pdf =
    (data?.documents[0]?.content) ||
    null;
  if (base64pdf) {
    const byteCharacters = atob(base64pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    let fileURL = URL.createObjectURL(blob);
    Browser.open({ url: `${fileURL}` });
  }
}
